module.exports = __webpack_public_path__ + "img/ic_24_shop_white.bbb2dc9d.svg";